import { render, staticRenderFns } from "./RotateScreen.vue?vue&type=template&id=87d283ea&"
import script from "./RotateScreen.vue?vue&type=script&lang=js&"
export * from "./RotateScreen.vue?vue&type=script&lang=js&"
import style0 from "./RotateScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports